module.exports = __webpack_public_path__ + "static/media/Strength.5c2bf23d.jpg";